import { Button as AntdButton, Button } from "antd";
import JobService from "../Service.js/jobService";
import { useEffect } from "react";
import React, { useState, useRef } from "react";
import { TbCurrencyRupee } from "react-icons/tb";
import { TiLocationArrowOutline } from "react-icons/ti";
import { MdOutlineWorkOutline } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import FooterLayout from "../Components/FooterLayout";
import tickIcon from "../Assets/Icons/tick.svg";
import CandidateLogin from "./CandidateLogin";
import cartIcon from "../Assets/Icons/cart.svg";
import toast from "react-hot-toast";
import cartIcon2 from "../Assets/Icons/cart2.svg";
import Multiselect from "multiselect-react-dropdown";
import { Popover } from "antd";
import { FaRegBookmark } from "react-icons/fa";
import { IoFilter } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import { PiBookmarkSimpleDuotone } from "react-icons/pi";
import londonbackground from "././../Assets/Icons/groupJobs.svg";
import Man from "././../Assets/Icons/Man.png";
import CheckboxGroup from "../Components/CommonCommponents/CheckboxGroup";
import { useForm } from "react-hook-form";
import HireHubHeader from "./HireHubHeader";

const MyJobs = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const inputRef = useRef(null);
  const [jobDetails, setJobDetails] = useState();
  const [open, setOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [filterData, setFilterData] = useState();
  const [serachString, setSearchString] = useState();

  // const currentUser = localStorage.getItem("candidate");
  console.log("currentIser", currentUser);
  const {
    register,
    control,
    setValue,
    reset,
    getValues,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const handelModal = () => {
    setIsFilter(!isFilter);
    setSearchString("");
    // console.log("filterDtata",selectedCheckboxes);
  };
  const handleCheckbox = (e, name) => {
    if (e.target.checked) {
      setSelectedCheckboxes([...selectedCheckboxes, name]); // Add the selected checkbox to the array
    } else {
      setSelectedCheckboxes(selectedCheckboxes.filter((item) => item !== name)); // Remove the deselected checkbox from the array
    }
  };
  const handleFilter = () => {
    console.log("filterDtata", selectedCheckboxes);
    // setFilterData(selectedCheckboxes)

    setIsFilter(false);
  };
  //   const handelApply = () =>{

  // filterData  cartList()
  //   }
  const options = [
    { label: "Saved", value: "saved" },
    {
      label: "Applied",
      value: "applied",
    },
    // { label: 'Open', value: 'OPEN', className: 'text-green-500' },
  ];
  const removeTags = (input) => {
    //return input.replace(/<[^>]*>/g, '');
    return input.replace(/<[^>]*>|&nbsp;/g, "");
  };
  console.log("filterData", selectedCheckboxes);
  const deleteCart = async (jobId) => {
    await JobService.deleteCart(jobId)
      .then((response) => {
        toast.success("Removed from BookMark");
        cartList();
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  const handleCart = async (jobId) => {
    await JobService.addToCart(jobId)
      .then((response) => {
        toast.success("Added To BookMark");
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  const truncateStrHandler = (str) => {
    const stringWithoutTags = removeTags(str);
    return stringWithoutTags.length > 65
      ? stringWithoutTags.substring(0, 65) + "  ....."
      : str;
  };
  const skillStrHandler = (str) => {
    return str.length > 10 ? str.substring(0, 8) + "..." : str;
  };
  const handleSearch = () => {
    cartList();
    // inputRef.current.value = '';;
  };
  const cartList = async (data) => {
    console.log("data", data);
    await JobService.cartList(data, serachString)
      .then((response) => {
        setJobDetails(response?.data?.data);
        setSearchString("");
      })
      .catch((err) => {});
  };
  console.log("jobDetails", jobDetails);
  useEffect(() => {
    cartList();
  }, []);
  const onSubmit = async (data) => {
    //setFilterData(data.filterBy)
    //cartList(filterData);
    setIsFilter(false);
    console.log("data", data);
    await JobService.cartList(data.filterBy, serachString)
      .then((response) => {
        setJobDetails(response?.data?.data);
        setSearchString("");
      })
      .catch((err) => {});
  };
  console.log("filter", filterData);
  return (
    <div className="w-full pageContent scrollbar-hide ">
      <div className="">
        <div className="mt-2 chart_div">
          <div className="flex items-center justify-end w-full lg:w-[72%]">
            {currentUser === null ? (
              <Link
                to="/login"
                className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0"
              >
                Sign In
              </Link>
            ) : (
              <HireHubHeader />
            )}
          </div>
          <div
            className="flex flex-row flex-wrap items-end w-4/6"
            style={{
              backgroundImage: `url(${londonbackground})`,
              backgroundSize: "cover",
            }}
          >
            <div className="">
              <img src={Man} alt="man" />
            </div>
            <div className="content-center md:w-3/4 sm:w-full">
              <div className="relative ">
                <input
                  type="text"
                  onChange={(e) => {
                    setSearchString(e.target.value);
                  }}
                  // value={serachString}
                  ref={inputRef} // Assign the ref to the input element
                  className="w-full p-4 yvi-input-feild"
                  placeholder={"Search Jobs"}
                />

                <Button
                  className="absolute px-10 right-3 top-3 custom-button"
                  onClick={handleSearch}
                >
                  Search
                </Button>
              </div>
            </div>
          </div>
          <div className="mt-20 1xl:w-5/6 xs-xl:w-5/6 lg:w-5/6 2xl:w-4/6 sm:w-full xs:w-full sm:px-4 xs:px-6">
            <div className="flex flex-row justify-between">
              <div className="flex mt-4">
                <p className="text-2xl font-semibold">Jobs</p>
                <div className="p-1 mx-4 border border-gray-400 rounded-full">
                  <p className="px-4 text-sm font-semibold ">
                    {jobDetails?.count} new jobs
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <Popover
                  title={
                    <div className="flex justify-end ">
                      <i className="px-2 pt-2 deleteIcon">
                        <IoMdClose
                          className="closeIcon"
                          onClick={handelModal}
                        />
                      </i>
                    </div>
                  }
                  open={isFilter}
                  onOpenChange={handelModal}
                  arrow={false}
                  trigger={"click"}
                  destroyTooltipOnHide
                  placement="bottomLeft"
                  content={
                    <div className="w-[15rem] flex flex-col p-4">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="items-baseline justify-start w-full">
                          <div className="w-60 ">
                            <CheckboxGroup
                              label="Filter By"
                              control={control}
                              name="filterBy"
                              options={options}
                              withCustomContent
                              isChangeLabelColor={true}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4 ">
                          <Button
                            type={"primary"}
                            htmlType="submit"
                            children={"Apply"}
                          />
                        </div>
                      </form>
                    </div>
                  }
                  overlayInnerStyle={{
                    padding: 0,
                  }}
                >
                  <Button
                    type="text"
                    children={
                      <div className="flex flex-row items-center gap-2">
                        <IoFilter size={"1.2rem"} color="#0A7F8F" />
                      </div>
                    }
                    className="text-[#0A7F8F] bg-white"
                  />
                </Popover>
              </div>
              {/* 
              <div className="mt-4">
                <Popover content={<div>Filter By</div>} placement="bottom">
                  <Button onClick={handelModal} className="bg-white rounded-md">
                    <IoFilter size={"1.2rem"} color="#0A7F8F" />
                  </Button>
                </Popover>
                {isFilter && (
                  <div className="absolute top-15 bg-[#fff]  w-[240px] h-[180px] p-4 mt-4">
                    <div className="flex items-center justify-between mt-4 mb-4">
                      <h2 className="text-sm font-medium">Filter By</h2>
                      <i className="deleteIcon">
                        <IoMdClose
                          className="closeIcon"
                          onClick={handelModal}
                        />
                      </i>
                    </div>
                    <div className="mt-6 space-y-2">
                      <label className="flex items-center ">
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          name="applied"
                          onChange={(e) => handleCheckbox(e, "applied")}
                          checked={selectedCheckboxes?.includes("applied")}
                        />
                        <span className="ml-2 text-sm ">Applied</span>
                      </label>
                      <label className="flex items-center pt-2">
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          name="saved"
                          onChange={(e) => handleCheckbox(e, "saved")}
                          checked={selectedCheckboxes?.includes("saved")}
                        />
                        <span className="ml-2 text-sm">BookMark</span>
                      </label>
                    </div>
                    <div className="flex justify-end mt-4">
                      <Button
                        className="bg-[#0A7F8F] text-white"
                        onClick={handleFilter}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                )}
              </div> */}
            </div>{" "}
            <div className="flex flex-row flex-wrap ">
              {jobDetails?.results?.map((item, index) => {
                const colors = ["#ffffff"];
                const noDataMessage = "Not Assigned";
                const locations = item.locations?.map((obj) => obj);

                return (
                  <div className="w-full px-2 mt-12 lg:w-1/2 md:w-full xl:w-1/2 ">
                    <div
                      className="p-3 border border-gray-300 cursor-pointer rounded-xl"
                      onClick={() => navigate(`/jobDetails/${item.id}`)}
                      style={{
                        backgroundColor: colors[index % colors.length],
                      }}
                    >
                      <div className="px-4 ">
                        <div className="flex flex-row justify-between ">
                          <div className="pt-1 mt-2 bg-white rounded-xl">
                            <p>{item?.posted}</p>
                          </div>
                          {currentUser ? (
                            item.is_saved === false ? (
                              <div className="pt-2">
                                <button disabled={item.applied === true}>
                                  <img
                                    alt="cart"
                                    title={
                                      item.applied === true ? "Disabled" : ""
                                    }
                                    src={cartIcon}
                                    style={{
                                      cursor:
                                        item.applied === true ? "pointer" : "",
                                    }}
                                    onClick={() => handleCart(item.id)}
                                  />
                                </button>
                              </div>
                            ) : (
                              <div className="pt-2">
                                <button disabled={item.applied === true}>
                                  <img
                                    alt="cart"
                                    className=""
                                    src={cartIcon2}
                                    onClick={() => deleteCart(item.id)}
                                  />
                                </button>
                              </div>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                        <Link to={`/jobDetails/${item.id}`}>
                          <p className="mt-2 text-base font-semibold">
                            {item?.title}
                          </p>
                        </Link>
                      </div>
                      <div className="w-full mx-4 mt-4">
                        <ul className="flex flex-wrap ">
                          <li className="w-full mb-4">
                            <div className="flex flex-wrap ">
                              {item.experience != false && (
                                <span className="flex items-center mr-4">
                                  <MdOutlineWorkOutline className="mr-2" />
                                  {item.experience}
                                </span>
                              )}
                              {item.experience != false &&
                                item.salary_details && (
                                  <span className="mx-4 divider">|</span>
                                )}
                              {item.salary_confidential === true ? (
                                <span className="flex items-center">
                                  <TbCurrencyRupee className="mr-2 contentIcon" />
                                  <p>As per the industrial standard</p>
                                </span>
                              ) : (
                                item.salary_details != false && (
                                  <span className="flex items-center">
                                    <TbCurrencyRupee className="mr-2 contentIcon" />
                                    {item.salary_details}
                                  </span>
                                )
                              )}

                              {(item.salary_details != false ||
                                item.salary_confidential != false) &&
                                item.job_type && (
                                  <span className="mx-4 divider">|</span>
                                )}
                              {item.experience != false &&
                                item.job_type &&
                                item.salary_details == false && (
                                  <span className="hidden mx-3 divider sm:inline-block">
                                    |
                                  </span>
                                )}
                              {item.job_type && (
                                <span className="flex items-center mr-4">
                                  <TiLocationArrowOutline className="mr-2 contentIcon" />
                                  {item.job_type}
                                </span>
                              )}
                            </div>
                          </li>
                        </ul>
                      </div>
                      {/* <div className="w-full mx-4 mt-4">
                          <ul className="flex flex-wrap ">
                            <li className="w-full mb-4">
                              <div className="flex flex-wrap ">
                                <span className="flex items-center mr-4">
                                  <MdOutlineWorkOutline className="mr-2" />
                                  {item?.experience || noDataMessage}
                                </span>
                                <span className="mx-4 divider">|</span>
                                <span className="flex items-center">
                                  <TbCurrencyRupee className="mr-2 contentIcon" />
                                  {item.salary_details || noDataMessage}
                                </span>
                                <span className="mx-4 divider">|</span>
                                <span className="flex items-center mr-4">
                                  <TiLocationArrowOutline className="mr-2 contentIcon" />
                                  {noDataMessage}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div> */}
                      <div className="mt-2">
                        <p
                          className="px-4 text-xs font-normal text-gray-600 font-poppins"
                          title={item.description}
                        >
                          {item?.description
                            ? removeTags(truncateStrHandler(item?.description))
                            : ""}
                        </p>
                      </div>
                      <div className="flex flex-wrap w-3/4 pb-4 mt-4 ">
                        {showAll
                          ? item.required_skill?.map((skill, index) => (
                              <div
                                key={index}
                                className="p-1 mx-4 mt-2 border border-gray-400 rounded-3xl"
                              >
                                <p
                                  className="px-2 pt-1 text-xs font-normal"
                                  title={skill}
                                >
                                  {skillStrHandler(skill)}
                                </p>
                              </div>
                            ))
                          : item.required_skill
                              ?.slice(0, 3)
                              .map((skill, index) => (
                                <div
                                  key={index}
                                  className="p-1 mx-4 mt-2 border border-gray-400 rounded-3xl"
                                >
                                  <p
                                    className="px-2 pt-1 text-xs font-normal"
                                    title={skill}
                                  >
                                    {skillStrHandler(skill)}
                                  </p>
                                </div>
                              ))}
                        {item.required_skill?.length > 3 && !showAll && (
                          <div
                            className="p-1 mt-2 cursor-pointer "
                            onClick={() => setShowAll(true)}
                          >
                            <p className="px-2 pt-1 text-xs font-normal text-gray-600">
                              ...more
                            </p>
                          </div>
                        )}
                      </div>

                      <div className="flex flex-row justify-between pl-2 mt-4">
                        <div>
                          <p>{locations.join("/")}</p>
                        </div>

                        <div className="flex flex-wrap">
                          <div>
                            {currentUser &&
                              item.show_document === false &&
                              item.applied === true && (
                                <button
                                  className="mt-2 font-medium text-blue-500 underline"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    //setModalOpen(true);
                                  }}
                                >
                                  <Link to={`/documents/${item.id}`}>
                                    Upload
                                  </Link>
                                </button>
                              )}
                          </div>
                          <div>
                            {/* <Button className='rounded-3xl text-white bg-[#0A0A0A]'>Apply</Button> */}
                            {currentUser === null ? (
                              <Button
                                className="rounded-3xl text-white bg-[#0A0A0A]"
                                onClick={showDrawer}
                              >
                                Login To Apply
                              </Button>
                            ) : item.applied === false ? (
                              <Button className="rounded-full text-white bg-[#1C4980] text-base font-semibold">
                                <Link to={`/jobDetails/${item.id}`}>Apply</Link>
                              </Button>
                            ) : (
                              <div className="flex px-5 py-1">
                                <button className="flex flex-wrap">
                                  <p className="px-2 text-[#1C4980] text-base font-semibold pt-1">
                                    Applied
                                  </p>

                                  <img
                                    src={tickIcon}
                                    alt="work"
                                    className="w-4 h-auto mt-2 mr-3 contentIcon"
                                  />
                                </button>
                              </div>
                            )}
                          </div>

                          {open && (
                            <CandidateLogin open={open} onClose={onClose} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="w-full mt-20">{/* <FooterLayout /> */}</div>
        </div>
      </div>
    </div>
  );
  // return (
  //   <>
  //     <div className="w-full pageContent scrollbar-hide ">
  //       <div className="xl:mx-20 2xl:40">
  //         <div>
  //           <div className="mt-20">
  //             <div className="flex flex-row justify-between px-20">
  //               <div>
  //                 <div className="flex mt-4">
  //                   <p className="text-2xl font-semibold">Jobs</p>
  //                   <div className="p-1 mx-4 border border-gray-400 rounded-full">
  //                     <p className="px-4 text-sm font-semibold ">
  //                       {jobDetails?.count} new jobs
  //                     </p>
  //                   </div>
  //                 </div>
  //               </div>
  //               <div className="content-center w-1/2">
  //                 <div className="relative ">
  //                   <input
  //                     type="text"
  //                     onChange={(e) => {
  //                       setSearchString(e.target.value);
  //                     }}
  //                     // value={serachString}
  //                     ref={inputRef} // Assign the ref to the input element
  //                     className="w-full p-4 yvi-input-feild"
  //                     placeholder={"Search Jobs"}
  //                   />

  //                   <Button
  //                     className="absolute px-10 right-3 top-3 custom-button"
  //                     onClick={handleSearch}
  //                   >
  //                     Search
  //                   </Button>
  //                 </div>
  //               </div>

  //               <div className="mt-4">
  //                 <Popover content={<div>Filter By</div>} placement="bottom">
  //                   <Button
  //                     onClick={handelModal}
  //                     className="bg-gray-100 rounded-md"
  //                   >
  //                     <IoFilter size={"1.2rem"} color="#0A7F8F" />
  //                     {/* <img src={filterIcon} alt="filterby" className='' /> */}
  //                   </Button>
  //                 </Popover>
  //                 {isFilter && (
  //                   <div className="absolute top-15 right-5 bg-[#fff]  w-[240px] h-[180px] p-4">
  //                     <div className="flex items-center justify-between mt-4 mb-4">
  //                       <h2 className="text-sm font-medium">Filter By</h2>
  //                       <i className="deleteIcon">
  //                         <IoMdClose
  //                           className="closeIcon"
  //                           onClick={handelModal}
  //                         />
  //                       </i>
  //                     </div>
  //                     <div className="mt-6 space-y-2">
  //                       <label className="flex items-center ">
  //                         <input
  //                           type="checkbox"
  //                           className="form-checkbox"
  //                           name="applied"
  //                           onChange={(e) => handleCheckbox(e, "applied")}
  //                           checked={selectedCheckboxes?.includes("applied")}
  //                         />
  //                         <span className="ml-2 text-sm ">Applied</span>
  //                       </label>
  //                       <label className="flex items-center pt-2">
  //                         <input
  //                           type="checkbox"
  //                           className="form-checkbox"
  //                           name="saved"
  //                           onChange={(e) => handleCheckbox(e, "saved")}
  //                           checked={selectedCheckboxes?.includes("saved")}
  //                         />
  //                         <span className="ml-2 text-sm">BookMark</span>
  //                       </label>
  //                     </div>
  //                     <div className="flex justify-end mt-4">
  //                       <Button
  //                         className="bg-[#0A7F8F] text-white"
  //                         onClick={handleFilter}
  //                       >
  //                         Apply
  //                       </Button>
  //                     </div>
  //                   </div>
  //                 )}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="flex flex-row flex-wrap px-20">
  //             {jobDetails?.results?.map((item, index) => {
  //               const colors = ["#F2F8F8"];
  //               const noDataMessage = "Not Assigned";
  //               const locations = item.locations?.map((obj) => obj);

  //               return (
  //                 <div className="px-2 mt-14 lg:w-1/2 md:w-full xl:w-1/2">
  //                   <div className="p-3 border border-gray-300 rounded-md">
  //                     <div
  //                       onClick={() => navigate(`/jobDetails/${item.id}`)}
  //                       className="rounded-lg cursor-pointer"
  //                       style={{
  //                         backgroundColor: colors[index % colors.length],
  //                       }}
  //                     >
  //                       <div className="px-4 ">
  //                         <div className="flex flex-row justify-between ">
  //                           <div className="px-2 pt-1 mt-2 bg-white rounded-xl">
  //                             <p>{item?.posted}</p>
  //                           </div>
  //                           {currentUser ? (
  //                             item.is_saved === false ? (
  //                               <div className="pt-2">
  //                                 <button disabled={item.applied === true}>
  //                                   <img
  //                                     alt="cart"
  //                                     title={
  //                                       item.applied === true ? "Disabled" : ""
  //                                     }
  //                                     src={cartIcon}
  //                                     style={{
  //                                       cursor:
  //                                         item.applied === true
  //                                           ? "pointer"
  //                                           : "",
  //                                     }}
  //                                     onClick={() => handleCart(item.id)}
  //                                   />
  //                                 </button>
  //                               </div>
  //                             ) : (
  //                               <div className="pt-2">
  //                                 <button disabled={item.applied === true}>
  //                                   <img
  //                                     alt="cart"
  //                                     className=""
  //                                     src={cartIcon2}
  //                                     onClick={() => deleteCart(item.id)}
  //                                   />
  //                                 </button>
  //                               </div>
  //                             )
  //                           ) : (
  //                             ""
  //                           )}
  //                         </div>
  //                         <Link to={`/jobDetails/${item.id}`}>
  //                           <p className="mt-2 text-base font-semibold">
  //                             {item?.title}
  //                           </p>
  //                         </Link>
  //                       </div>
  //                       <div className="w-full mx-4 mt-4">
  //                         <ul className="flex flex-wrap ">
  //                           <li className="w-full mb-4">
  //                             <div className="flex flex-wrap ">
  //                               {item.experience != false && (
  //                                 <span className="flex items-center mr-4">
  //                                   <MdOutlineWorkOutline className="mr-2" />
  //                                   {item.experience}
  //                                 </span>
  //                               )}
  //                               {item.experience != false &&
  //                                 item.salary_details && (
  //                                   <span className="mx-4 divider">|</span>
  //                                 )}
  //                               {item.salary_confidential === true ? (
  //                                 <span className="flex items-center">
  //                                   <TbCurrencyRupee className="mr-2 contentIcon" />
  //                                   <p>As per the industrial standard</p>
  //                                 </span>
  //                               ) : (
  //                                 item.salary_details != false && (
  //                                   <span className="flex items-center">
  //                                     <TbCurrencyRupee className="mr-2 contentIcon" />
  //                                     {item.salary_details}
  //                                   </span>
  //                                 )
  //                               )}

  //                               {(item.salary_details != false ||
  //                                 item.salary_confidential != false) &&
  //                                 item.job_type && (
  //                                   <span className="mx-4 divider">|</span>
  //                                 )}
  //                               {item.experience != false &&
  //                                 item.job_type &&
  //                                 item.salary_details == false && (
  //                                   <span className="hidden mx-3 divider sm:inline-block">
  //                                     |
  //                                   </span>
  //                                 )}
  //                               {item.job_type && (
  //                                 <span className="flex items-center mr-4">
  //                                   <TiLocationArrowOutline className="mr-2 contentIcon" />
  //                                   {item.job_type}
  //                                 </span>
  //                               )}
  //                             </div>
  //                           </li>
  //                         </ul>
  //                       </div>
  //                       {/* <div className="w-full mx-4 mt-4">
  //                         <ul className="flex flex-wrap ">
  //                           <li className="w-full mb-4">
  //                             <div className="flex flex-wrap ">
  //                               <span className="flex items-center mr-4">
  //                                 <MdOutlineWorkOutline className="mr-2" />
  //                                 {item?.experience || noDataMessage}
  //                               </span>
  //                               <span className="mx-4 divider">|</span>
  //                               <span className="flex items-center">
  //                                 <TbCurrencyRupee className="mr-2 contentIcon" />
  //                                 {item.salary_details || noDataMessage}
  //                               </span>
  //                               <span className="mx-4 divider">|</span>
  //                               <span className="flex items-center mr-4">
  //                                 <TiLocationArrowOutline className="mr-2 contentIcon" />
  //                                 {noDataMessage}
  //                               </span>
  //                             </div>
  //                           </li>
  //                         </ul>
  //                       </div> */}
  //                       <div className="mt-2">
  //                         <p
  //                           className="px-4 text-xs font-normal text-gray-600 font-poppins"
  //                           title={item.description}
  //                         >
  //                           {removeTags(truncateStrHandler(item.description))}
  //                         </p>
  //                       </div>
  //                       <div className="flex flex-wrap w-3/4 pb-4 mt-4 ">
  //                         {showAll
  //                           ? item.required_skill?.map((skill, index) => (
  //                               <div
  //                                 key={index}
  //                                 className="p-1 mx-4 mt-2 border border-gray-400 rounded-3xl"
  //                               >
  //                                 <p
  //                                   className="px-2 pt-1 text-xs font-normal"
  //                                   title={skill}
  //                                 >
  //                                   {skillStrHandler(skill)}
  //                                 </p>
  //                               </div>
  //                             ))
  //                           : item.required_skill
  //                               ?.slice(0, 3)
  //                               .map((skill, index) => (
  //                                 <div
  //                                   key={index}
  //                                   className="p-1 mx-4 mt-2 border border-gray-400 rounded-3xl"
  //                                 >
  //                                   <p
  //                                     className="px-2 pt-1 text-xs font-normal"
  //                                     title={skill}
  //                                   >
  //                                     {skillStrHandler(skill)}
  //                                   </p>
  //                                 </div>
  //                               ))}
  //                         {item.required_skill?.length > 3 && !showAll && (
  //                           <div
  //                             className="p-1 mt-2 cursor-pointer "
  //                             onClick={() => setShowAll(true)}
  //                           >
  //                             <p className="px-2 pt-1 text-xs font-normal text-gray-600">
  //                               ...more
  //                             </p>
  //                           </div>
  //                         )}
  //                       </div>
  //                     </div>

  //                     <div className="flex flex-row justify-between mt-4">
  //                       <div>
  //                         <p>{locations.join("/")}</p>
  //                       </div>
  //                       <div className="flex flex-wrap">
  //                         <div>
  //                           {currentUser &&
  //                             item.show_document === false &&
  //                             item.applied === true && (
  //                               <button className="mt-2 font-medium text-blue-500 underline">
  //                                 <Link to={`/documents/${item.id}`}>
  //                                   Upload
  //                                 </Link>
  //                               </button>
  //                             )}
  //                         </div>
  //                         <div>
  //                           {/* <Button className='rounded-3xl text-white bg-[#0A0A0A]'>Apply</Button> */}
  //                           {currentUser === null ? (
  //                             <Button
  //                               className="rounded-3xl text-white bg-[#0A0A0A]"
  //                               onClick={showDrawer}
  //                             >
  //                               Login To Apply
  //                             </Button>
  //                           ) : item.applied === false ? (
  //                             <Button className="rounded-3xl text-white bg-[#0A0A0A]">
  //                               <Link to={`/jobDetails/${item.id}`}>Apply</Link>
  //                             </Button>
  //                           ) : (
  //                             <div className="flex px-5 py-1">
  //                               <button className="flex flex-wrap">
  //                                 <p className="px-2 mt-1 text-base font-medium text-green-600">
  //                                   Applied
  //                                 </p>

  //                                 <img
  //                                   src={tickIcon}
  //                                   alt="work"
  //                                   className="w-4 h-auto mt-2 mr-3 contentIcon"
  //                                 />
  //                               </button>
  //                             </div>
  //                           )}
  //                         </div>

  //                         {open && (
  //                           <CandidateLogin open={open} onClose={onClose} />
  //                         )}
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               );
  //             })}
  //           </div>
  //         </div>
  //       </div>
  //       <div className="h-[1px] bg-[#EAEAEA] mt-10"></div>
  //       <div>
  //         <FooterLayout />
  //       </div>
  //     </div>
  //   </>
  // );
};
export default MyJobs;
